/**
 * Formats a numeric chip number with dot separators every 3 digits from the right.
 * Example: 1899998 → "1.899.998"
 */
export const formatChipNumber = (value: number | string | undefined | null): string => {
  if (value === undefined || value === null || value === 0) return '';
  return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
};

/**
 * Parses a dot-formatted chip number string back to a number.
 * Example: "1.899.998" → 1899998
 */
export const parseChipNumber = (formatted: string): number => {
  const digits = formatted.replace(/\D/g, '');
  return digits ? Number(digits) : 0;
};
